import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { ManagerProgressionTaskState } from '@sorare/core/src/__generated__/globalTypes.ts';
import { Raffle } from '@sorare/core/src/atoms/icons/Raffle';
import { Badge } from '@sorare/core/src/atoms/ui/Badge/index.tsx';
import { Orb } from '@sorare/core/src/components/Orb';
import { ANY_SPORT_SERIES_RAFFLE } from '@sorare/core/src/constants/__generated__/routes.ts';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser/index.ts';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { TimeLeft } from '@sorare/core/src/contexts/ticker/TimeLeft/index.tsx';

import type { RaffleWidget_raffle } from './__generated__/index.graphql.ts';

type Props = {
  raffle: RaffleWidget_raffle;
};
export const RaffleWidget = ({ raffle }: Props) => {
  const { generateSportContextPath } = useSportContext();
  const { endDate, myRaffleTasks } = raffle;
  const { currentUser } = useCurrentUserContext();
  const raffleTickets = currentUser?.raffleTickets?.at(0)?.amount ?? 0;

  const showNewChip = raffleTickets === 0;
  const completedTasksCount = myRaffleTasks.filter(
    task => task.aasmState === ManagerProgressionTaskState.COMPLETED
  ).length;

  return (
    <Orb
      to={generateSportContextPath(ANY_SPORT_SERIES_RAFFLE)}
      color="var(--c-raffle)"
      chipState={showNewChip ? 'new' : 'timeLeft'}
      label={showNewChip ? undefined : <TimeLeft time={endDate} />}
    >
      <Badge badgeContent={completedTasksCount} overlap="circular">
        <Raffle />
      </Badge>
    </Orb>
  );
};

RaffleWidget.fragments = {
  raffle: gql`
    fragment RaffleWidget_raffle on Raffle {
      slug
      endDate
      myRaffleTasks {
        id
        aasmState
      }
    }
  ` as TypedDocumentNode<RaffleWidget_raffle>,
};
